module.exports = __webpack_public_path__ + "videos/bg_main_new.788e3ca.mp4";